import { gql } from '@apollo/client';

export const GetLapYearsQuery = gql`
    query GetLapYears {
        getLapYears
    }
`;
